import React, { ReactNode } from "react";

const Conditional = ({
  when,
  show,
  children,
}: {
  when: boolean;
  show: ReactNode;
  children: ReactNode;
}) => {
  if (when) {
    return show;
  }
  return children;
};
export default React.memo(Conditional);
